import { requestJson } from "recipal-app/controllers/shared/requests.js";
import { purchaseOrderOrderItemPath, purchaseOrderOrderItemsPath } from "~/routes.js";

export const createOrderItem = (orderId, orderItem) =>
  requestJson(purchaseOrderOrderItemsPath(orderId), {
    method: "POST",
    body: JSON.stringify({ order_item: orderItem }),
  });

export const updateOrderItem = (orderId, itemId, orderItem) =>
  requestJson(purchaseOrderOrderItemPath(orderId, itemId), {
    method: "PATCH",
    body: JSON.stringify({ order_item: orderItem }),
  });

export const deleteOrderItem = (orderId, itemId) =>
  requestJson(purchaseOrderOrderItemPath(orderId, itemId), {
    method: "DELETE",
  });
